import { ColumnState } from '@ag-grid-community/core';
import { COLUMN_ID } from '@urc-ui/pages/landing/subscriptions-table/column-configurations';
import { Sort } from '@urc-ui/store/api/types';
import { DEFAULT_SORT_CONFIG } from '@urc-ui/store/api/subscriptions/subscriptions';

const SORT_COLUMN_TO_CORVO_COLUMN: { [key: string]: string } = {
  ['SUBSCRIPTION_STATUS']: COLUMN_ID.STATUS,
  ['SUBSCRIPTION_NAME']: COLUMN_ID.REPORT_NAME
};

/**
 * Translates the found ColumnState with an active sort applied to a Sort object readable to a GetSubscriptionsRequest.
 * Translates the UI data table Column Id to the equal Corvo ColumnName.
 *
 * @param column A ColumnState that has been identified to contain a non-null sort attribute.
 */
const determineSortfromColumnState = (column: ColumnState) => {
  const columnSort: Sort = { columnName: '', order: '' };

  if (column.colId === COLUMN_ID.STATUS) {
    columnSort.columnName = 'SUBSCRIPTION_STATUS';
  } else if (column.colId === COLUMN_ID.REPORT_NAME) {
    columnSort.columnName = 'SUBSCRIPTION_NAME';
  } else {
    return DEFAULT_SORT_CONFIG;
  }

  if (column.sort === 'asc') {
    columnSort.order = column.sort.toUpperCase();
  } else if (column.sort === 'desc') {
    columnSort.order = column.sort.toUpperCase();
  }
  return columnSort;
};

/**
 * Translates the Sort object to it's ColumnState by converting the Corvo ColumnName to the UI Column Id.
 * Returns null if by chance the Sort object is of an unsupported column.
 *
 * @param sort the saved Sort object that is passed into a GetSubscriptionsRequest
 */
export const determineColumnStateFromSort = (sort: Sort) => {
  if (!SORT_COLUMN_TO_CORVO_COLUMN[sort.columnName]) {
    return null;
  }
  return { colId: SORT_COLUMN_TO_CORVO_COLUMN[sort.columnName], sort: sort.order.toLowerCase() } as ColumnState;
};

/**
 * Determines the current sorted column selected by the user from the list of ColumnState.
 *
 * @param columns the current state of columns of the data table grid.
 */
export const findSortedColumn = (columns: ColumnState[]) => {
  let sortedColumn: Sort = DEFAULT_SORT_CONFIG;
  columns.forEach(column => {
    if (column.sort !== null) {
      sortedColumn = determineSortfromColumnState(column);
      return; //breaks out-of forEach
    }
  });
  return sortedColumn;
};
